import { ResourceType } from '../../types';
import DrawerSection from '../DrawerSection';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import DrawerResource from '../DrawerResource';
import { SliderActions } from 'components/common/SliderWithActions/SliderActions';
import { useRef, useState } from 'react';
import { ResourcesContainer, SlidesInfo } from './Resources.styled';

const settings = {
    dots: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    autoplay: false,
    speed: 1000,
    autoplaySpeed: 2000,
    arrows: false
};

export const Resources = ({ resources, stationName }: { resources?: ResourceType[]; stationName: string }) => {
    const sliderRef = useRef<Slider>(null);

    const next = () => sliderRef.current?.slickNext();
    const previous = () => sliderRef.current?.slickPrev();
    const [currentSlide, setCurrentSlide] = useState<number>(0);

    return resources?.length ? (
        <ResourcesContainer>
            <DrawerSection header="Additional resources" style={{ width: 'calc(100%  + 2.4rem)' }}>
                <div style={{ width: '100%' }}>
                    <Slider {...settings} ref={sliderRef} afterChange={setCurrentSlide}>
                        {resources.map((resource, index) => (
                            <DrawerResource
                                key={resource.title || resource.link}
                                position={index + 1}
                                resource={resource}
                                stationName={stationName}
                            />
                        ))}
                    </Slider>
                </div>
                <SliderActions next={next} previous={previous} currentSlide={currentSlide} slidesLength={resources.length}>
                    <SlidesInfo>{currentSlide + 1 + ' / ' + resources.length}</SlidesInfo>
                </SliderActions>
            </DrawerSection>
        </ResourcesContainer>
    ) : null;
};
